import { findWhere } from "underscore";
import { useAtomValue } from "jotai";

import ImportDataWidget from "components/Widgets/ImportDataWidget/ImportDataWidget";
import ModulePicker from "components/Modules/ModulePicker";
import { modulesAtom } from "atoms/GlobalAtoms";

/**
 * RecordCreateUpdate
 */
const RecordCreateUpdate = ({ action, setAction, actions }) => {
  const modules = useAtomValue(modulesAtom);

  const handleChange = (newPayload) => {
    setAction((prev) => ({
      ...prev,
      ...newPayload,
    }));
  };

  const handleNewModule = (newMod) => {
    if (!newMod) return;

    const module = findWhere(modules, { APIName: newMod });

    if (!module) return;

    const payload = {
      ModuleAPIName: newMod,
      Name: `Import & Update ${module?.Name} Records`,
      Description: `In the ${module?.Name} data source, records will be imported using the provided file/data.`,
    };

    setAction((prev) => ({ ...prev, ...payload }));
  };

  return (
    <>
      <h3>Data Source</h3>
      <ModulePicker
        value={action?.ModuleAPIName}
        onChange={(newMod) => handleNewModule(newMod)}
        size="md"
        defaultOpen={!action?.ModuleAPIName}
        omitGlobalModules={true}
      />
      <div className="mt-4">
        {action?.ModuleAPIName && (
          <>
            <ImportDataWidget
              moduleAPIName={action?.ModuleAPIName}
              onChange={handleChange}
              actions={actions}
              existingData={action}
              usesActions
            />
          </>
        )}
      </div>
    </>
  );
};

export default RecordCreateUpdate;
